import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Col,
  Row,
  Container,
  Stack,
} from "react-bootstrap";
import L, { point } from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  GeoJSON,
  useMapEvent,
  LayersControl,
  AttributionControl,
} from "react-leaflet";
import { FaLocationDot, FaCircleCheck, FaCircleXmark } from "react-icons/fa6";
import ExportKMLButton from "../../../Style_Component/Button/Exportcoord/ExportKMLButton";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
});

function UserOperationContentModal(props) {
  function formatDate(inputString) {
    const date = new Date(inputString);
    const padZero = (num) => (num < 10 ? "0" : "") + num;

    const day = padZero(date.getDate());
    const month = padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  function arrayToString(inputArray) {
    console.log(inputArray);
    return inputArray.map((obj) => `${obj.Lon},${obj.Lat}`).join(" , ");
  }

  function positionsArrayToPolygon(inputArray) {
    const storeArray = [];
    const polygonData = props.content.positions;
    polygonData.map((content, index) => {
      storeArray.push([content.Lat, content.Lon]);
    });
    return storeArray;
  }

  function matchingPurpose(purposeNumber) {
    switch (purposeNumber) {
      case "1":
        return "เพื่อการเล่นเป็นงานอดิเรก ความบันเทิง หรือ เพื่อการกีฬา";
      case "2":
        return "เพื่อการรายงานเหตุการณ์หรือรายงานจราจร (สื่อมวลชน)";
      case "3":
        return "เพื่อการวิจัย ทดลอง ทดสอบ ตามประกาศ กสทช.";
      case "4":
        return "เพื่อการวิจัยและพัฒนาอากาศยาน เพื่อการพาณิชย์";
      case "5":
        return "เพื่อการถ่ายภาพ ถ่ายทำหรือการแสดงในภาพยนต์หรือรายการโทรทัศน์";
      case "6":
        return "เพื่อสำรวจสิ่งปลูกสร้าง";
      default:
        return "อื่นๆ";
    }
  }

  //   function copyCoordinate() {
  //     const coordinates = props.content.positions;

  //     const geoJson = {
  //       type: "FeatureCollection",
  //       features: [
  //         {
  //           type: "Feature",
  //           geometry: {
  //             type: "Polygon",
  //             coordinates: [props.content.positions],
  //           },
  //           properties: {},
  //         },
  //       ],
  //     };

  //     let kmlCoordinates = "";
  //     coordinates.forEach((coord) => {
  //       kmlCoordinates += `${coord.Lon},${coord.Lat} `;
  //     });

  //     kmlCoordinates = kmlCoordinates.trim();

  //     const kml = `<?xml version="1.0" encoding="UTF-8"?>
  // <kml xmlns="http://www.opengis.net/kml/2.2">
  //   <Document>
  //     <Placemark>
  //       <Polygon>
  //         <outerBoundaryIs>
  //           <LinearRing>
  //             <coordinates>
  //               ${kmlCoordinates}
  //             </coordinates>
  //           </LinearRing>
  //         </outerBoundaryIs>
  //       </Polygon>
  //     </Placemark>
  //   </Document>
  // </kml>`;

  //     console.log(kml);
  //     function downloadKML(kmlContent, filename) {
  //       const blob = new Blob([kmlContent], {
  //         type: "application/vnd.google-earth.kml+xml",
  //       });
  //       const a = document.createElement("a");
  //       const url = URL.createObjectURL(blob);
  //       a.href = url;
  //       a.download = filename;
  //       a.click();
  //       URL.revokeObjectURL(url);
  //       a.remove();
  //     }

  //     downloadKML(kml, "coordinates.kml");
  //     navigator.clipboard.writeText(kml);
  //   }

  return (
    <Modal
      show={props.toggleModal}
      onHide={props.onHide} // Use the onHide prop to handle closing the modal
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>แจ้งเตือน</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col xs={7}>
              <MapContainer
                center={[
                  props.content.positions[0].Lat,
                  props.content.positions[0].Lon,
                ]}
                zoom={13}
                keyboard={true}
                style={{
                  width: "100%",
                  height: "500px",
                  borderRadius: "25px",
                  border: "5px solid black",
                }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Polygon
                  pathOptions={{ color: "blue" }}
                  positions={positionsArrayToPolygon(props.content.positions)}
                />
              </MapContainer>
            </Col>
            <Col xs={5}>
              <Stack gap={3}>
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <p>รหัสปฏิบัติการ</p>
                  <p style={{ lineHeight: 1.5 }}>{props.content.id}</p>
                </div>
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <p>ประเภทการปฏิบัติการ</p>
                  <p>{((props.content.type)?.split("-"))[0]}</p>
                </div>
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <Row>
                    <Col>
                      <p>เวลาเริ่มต้น</p>
                      <p>{formatDate(props.content.start)}</p>
                    </Col>
                    <Col>
                      <p>เวลาสิ้นสุด</p>
                      <p>{formatDate(props.content.end)}</p>
                    </Col>
                  </Row>
                </div>
                {/* <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <p>พิกัด</p>
                  <p>
                    {arrayToString(props.content.positions).substring(0, 54)}...
                  </p>
                </div> */}
                
                  <div className="p-2" style={{ lineHeight: 0.5 }}>
                    <Row>
                      <Col>
                        <p>นักบิน</p>
                        <p>{props.content.pilot_name ?? "-"}</p>
                      </Col>
                      <Col>
                        <p>รุ่นอากาศยาน</p>
                        <p>{props.content.drone_model ?? "-"}</p>
                      </Col>
                    </Row>
                  </div>
                

                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <Row>
                    <Col>
                      <p>วัตถุประสงค์</p>
                      <p style={{ lineHeight: 1.5 }}>
                        {matchingPurpose(props.content.purpose)}
                      </p>
                    </Col>
                  </Row>
                </div>
                <div className="p-2" style={{ lineHeight: 0.5 }}>
                  <Row>
                    <Col>
                      <ExportKMLButton positions={props.content.positions} />
                      {/* <Button onClick={copyCoordinate}>
                        <FaLocationDot style={{ marginBottom: "3px" }} />
                        &nbsp; คัดลอกพิกัด
                      </Button> */}
                    </Col>
                  </Row>
                </div>
              </Stack>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <button    className="custom-btn btnCancel" onClick={props.onHide}>Close</button>
      </Modal.Footer>
    </Modal>
  );
}

export default UserOperationContentModal;
